import React from 'react';
import Alert from '../../../Components/Alert';
import { useMyQuestionnaires, isAwaitingQuestionnaireResponse, questionnaireTitle } from '../../../Data/Questionnaires';
import { useRedirect } from '../../../Services/helpers';

const Questionnaires = () => {
    const { questionnaires, isLoading } = useMyQuestionnaires(true);
    const { go } = useRedirect();
    const awaitingQuestionnaires = (questionnaires ?? []).filter(isAwaitingQuestionnaireResponse);

    if (isLoading || awaitingQuestionnaires.length === 0) {
        return null;
    }

    return <>
        {awaitingQuestionnaires.map((questionnaire) => (
            <Alert
                key={questionnaire.id}
                theme="info"
                icon={questionnaire.icon || 'ListCheck'}
                title={questionnaireTitle(questionnaire)}
                message={questionnaire.teaser || 'Tap to complete this questionnaire.'}
                onClick={() => go(`/questionnaires/${questionnaire.id}`)}
            />
        ))}
    </>;
};

export default Questionnaires;
